import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { cloneDeep } from 'lodash'

import useToasterHelper from '../../../../helpers/ToasterHelper'
import { useCreate } from '../../../useCreate'

// Redux
import { useAppDispatch } from '../../../../store/hooks'
import { storeUseMode } from '../../../../store/system/systemThunk'
import {
  setIsLoggedIn,
  setProfileDetails,
  setUserId,
  storeUserId,
} from '../../../../store/user/userSlice'

// Services
import FirestoreService from '../../../../services/firestoreService'

import { IInputUserData, IInputUserKey } from '../../../../components/home/types/inputData'
import { UserModel } from '../../../../models/users/user.model'

// Constants
import { CONST } from '../../../../const/const'
import { authHelpers } from '../../../../helpers/helpers'

const useUserAccountHook = () => {
  const auth = getAuth()
  const dispatch = useAppDispatch()
  const toastFunctions = useToasterHelper()
  const { getFirebaseErrors } = useCreate()

  const handleOnLoginValid = async ({
    email,
    password,
    onSuccess,
  }: {
    email: string
    password: string
    onSuccess?: (userId: string) => void
  }) => {
    try {
      const emailOrUsername = await authHelpers.getEmail(email)

      if (!emailOrUsername) {
        return toastFunctions.error({ message: 'Invalid email address or username' })
      }

      const user = await signInWithEmailAndPassword(auth, emailOrUsername, password)

      if (user) {
        const user_data_doc: any = await FirestoreService.getItem(
          CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.USERS.NAME,
          user.user.uid
        )

        const userData = UserModel.fromFirestoreDoc(user_data_doc).toObject()
        dispatch(setProfileDetails(userData))

        if (userData.userType === CONST.USE_MODE.COMPETITOR) {
          dispatch(storeUseMode(CONST.USE_MODE.COMPETITOR))
        } else if (userData.userType === CONST.USE_MODE.ORGANIZER) {
          dispatch(storeUseMode(CONST.USE_MODE.ORGANIZER))
        }

        dispatch(setIsLoggedIn(true))
        dispatch(storeUserId(user.user.uid))
        dispatch(setUserId(user.user.uid))
      }

      if (onSuccess) onSuccess(user.user.uid)
    } catch (error: any) {
      console.error(error, 'error')
      toastFunctions.error({ message: getFirebaseErrors(error) })
    }
  }

  const checkValidity = (inputData: IInputUserData) => {
    for (const key in inputData) {
      const field = inputData[key as IInputUserKey]
      if (field.required && !field.value) {
        return false
      }
    }
    return true
  }

  const onChangeHandler = (data: IInputUserData, key: string, value: string) => {
    const newInputData = cloneDeep(data)
    if (newInputData[key as IInputUserKey]) {
      newInputData[key as IInputUserKey].value = value
      newInputData[key as IInputUserKey].hasError = false
    }

    return newInputData
  }

  return { handleOnLoginValid, checkValidity, onChangeHandler }
}

export default useUserAccountHook
